import { Grid, Stack } from "@mui/material"
import { UPMain, UPWrapper } from "./Atom"
import { UserProfileHeader } from "../../components/Headers"
import { UserDetails, UserInfo } from "../../components/Cards"
import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { getTokenLocal } from "../../../helper/utils"
import { setLoading } from "../../redux/slices/appSlice"
import { useResponseHandle } from "../../hooks"
import { useSelector } from "react-redux"
import { useDispatch } from "react-redux"
import UserAPI from "../../../api/user"
import { setUserProfileData } from "../../redux/slices/userSlice"

const userAPI = new UserAPI()

const UserProfile = () => {
  const selectedUserId = useSelector((state: any) => state.user?.selectedUserId)
  const userProfileData = useSelector(
    (state: any) => state.user?.userProfileData,
  )

  const dispatch = useDispatch()

  const navigate = useNavigate()

  const token: any = getTokenLocal()

  const fetchUserDetails = async () => {
    dispatch(setLoading(true))

    const response = await userAPI.getUserByUserId(token, selectedUserId)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      dispatch(setUserProfileData(result?.data))
    } else {
      navigate("/auth")
    }

    dispatch(setLoading(false))

    return result
  }

  useEffect(() => {
    if (!selectedUserId) {
      navigate("/users")
    } else {
      fetchUserDetails()
    }
  }, [])

  return (
    <UPWrapper>
      <UserProfileHeader name="User Profile" />
      <UPMain>
        <Stack
          display={"flex"}
          direction={"row"}
          spacing={2}
          paddingX={"25px"}
          paddingBottom={"35px"}
          height={"100%"}
        >
          <Grid sx={{ width: "25%" }}>
            <UserInfo fetchUserDetails={fetchUserDetails} />
          </Grid>
          <Grid sx={{ width: "75%" }}>
            <UserDetails fetchUserDetails={fetchUserDetails} />
          </Grid>
        </Stack>
      </UPMain>
    </UPWrapper>
  )
}

export default UserProfile
